import { Skeleton } from 'antd';
import React from 'react';

const TableSkeleton = ({ rows = 5, columns = 5 }) => {
    return (
        <div className="w-full overflow-hidden rounded-xl border border-[#d4d9e3] bg-white">
            <table className="w-full">
                <thead>
                    <tr className="bg-gray-50 border-b border-[#d4d9e3]">
                        {Array.from({ length: columns }).map((_, i) => (
                            <th key={i} className="px-4 py-3 text-left">
                                <Skeleton.Button active size="small" block />
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {Array.from({ length: rows }).map((_, rowIndex) => (
                        <tr key={rowIndex} className="border-b border-[#d4d9e3] last:border-0">
                            {Array.from({ length: columns }).map((_, colIndex) => (
                                <td key={colIndex} className="px-4 py-4">
                                    <Skeleton.Input active size="small" block />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TableSkeleton;
